// extracted by mini-css-extract-plugin
module.exports = {"title":"Game_title__3HLoG","resetButton":"Game_resetButton__1bht_"};